
import { App } from 'vue'
import { forEach, camelCase, upperFirst } from 'lodash-es'
import installVueJsModal from '@/plugins/vue-final-modal'
import installClickOutsideVue3 from '@/plugins/click-outside-vue3'
import installToasts from '@/plugins/vue-toastification'

import globalMixin from '@/assets/mixins/global-mixin'
import { attachInterceptor, setReactiveBreakpoints } from 'mega-composable'
import axios from 'axios'
import sassExports from '@/assets/styles/main.scss'

const pascalCase = (name: string) => upperFirst(camelCase(name))
function registerComponents(app: App<Element>) {
  const context = require.context('@/components', true, /\w+\.(vue)$/)
  forEach(context.keys(), fileName => {
    const componentConfig = context(fileName)
    const name = (fileName.split('/').pop() || '').replace(/\.\w+$/, '')
    const componentName = pascalCase(name)
    const component = componentConfig.default || componentConfig
    app.component(componentName, component)
  })
}

async function installPlugins(app: App<Element>) {
  installVueJsModal(app)
  installClickOutsideVue3(app)
  installToasts(app)
}

export async function initialize(app: App<Element>) {
  app.mixin(globalMixin)
  setReactiveBreakpoints(sassExports)
  attachInterceptor(axios)
  registerComponents(app)
  installPlugins(app)
}
